// In React Router v7, we use the navigate function from useNavigate hook
// This file now exports helper functions that work with window.location for backwards compatibility
// Components should migrate to use useNavigate hook directly

// Create a navigate function that will be set by the NavigationProvider
let navigateFunction = null;

export const setNavigateFunction = (navigate) => {
    navigateFunction = navigate;
};

const getNavigate = () => {
    if (navigateFunction) {
        return navigateFunction;
    }
    // Fallback to window.location for cases where navigate isn't available
    return null;
};

// For backwards compatibility - allows access from other components without having to pass props
const History = {
    push: (path, state) => {
        const navigate = getNavigate();
        if (navigate) {
            navigate(path, { state });
        } else {
            window.location.href = path;
        }
    },
    replace: (path, state) => {
        const navigate = getNavigate();
        if (navigate) {
            navigate(path, { replace: true, state });
        } else {
            window.location.replace(path);
        }
    }
};

export default History;

// no url param is preserved 
export const hardRedirect = (url, state="") => {
    History.push(url, state);
};
  

// one url param will be preserved
export const redirectTo = (url, state="") => {
    const searchParams = window.location.search;
    if (searchParams.length > 0) {
        const params = searchParams.split('=');
        const name = encodeURIComponent(params[0].slice(1));
        const value = encodeURIComponent(params[1]);
        History.push(`${url}?${name}=${value}`, state);
    } else {
        History.push(url, state);
    }
}

// one url param will be preserved
export const replaceWith = (url, state="") => {
    const searchParams = window.location.search;
    if (searchParams.length > 0) {
        const params = searchParams.split('=');
        const name = encodeURIComponent(params[0].slice(1));
        const value = encodeURIComponent(params[1]);
        History.replace(`${url}?${name}=${value}`, state);
    } else {
        History.replace(url, state);
    }
}
